import { render, staticRenderFns } from "./TransportInfoList.vue?vue&type=template&id=036ee82f&scoped=true&"
import script from "./TransportInfoList.vue?vue&type=script&lang=js&"
export * from "./TransportInfoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036ee82f",
  null
  
)

export default component.exports